import { motion } from "framer-motion";
import { BENEFITS } from "../../data";
import { Reveal, Overline } from "./Reveal";
import { neutralizeWA } from "../../config";

export default function Perche() {
  return (
    <section id="perche" className="relative bg-surface py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="max-w-3xl">
          <Reveal><Overline>Perché sceglierci</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display font-extrabold tracking-tight text-navy text-4xl sm:text-5xl">
              Serietà, precisione e comunicazione semplice
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon;
            return (
              <motion.div
                key={b.title}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: (i % 4) * 0.08 }}
                className="relative"
              >
                <span className="font-display font-extrabold text-6xl sm:text-7xl text-navy/[0.07] leading-none select-none">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="-mt-8 relative">
                  <Icon size={28} strokeWidth={1.6} className="text-brand-orange" />
                  <h3 className="mt-3 font-display font-bold text-lg text-navy">{b.title}</h3>
                  <p className="mt-2 text-sm text-ink/60 leading-relaxed">{neutralizeWA(b.desc)}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
